import { Paper, Stack, Typography, Button } from "@mui/material";

export const authCardSx = {
  bgcolor: "#fff",
  borderRadius: "15px",
  boxShadow: "1px 5px 5px 1px rgba(0,0,0,0.12)",
  p: { xs: 3, sm: 7 },
  width: "100%",
  maxWidth: 440,
};

export const authFieldSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px",
  },
};

export const authButtonSx = {
  textTransform: "none",
  fontWeight: 600,
  borderRadius: "10px",
  py: 1.25,
};

const AuthCard = ({
  title,
  subtitle,
  children,
  footerTitle,
  footerActionLabel,
  onFooterAction,
  footerActions = [],
}) => {
  const actions =
    footerActions.length > 0
      ? footerActions
      : footerActionLabel && onFooterAction
        ? [{ label: footerActionLabel, onClick: onFooterAction }]
        : [];

  return (
    <Stack
      spacing={2}
      alignItems="center"
      sx={{
        width: "100%",
        maxWidth: 440,
        mx: "auto",
      }}
    >
      <Paper elevation={0} sx={authCardSx}>
        <Stack spacing={0.75} sx={{ mb: 3, textAlign: "center" }}>
          <Typography variant="h5" sx={{ fontWeight: 700, color: "black" }}>
            {title}
          </Typography>
          {subtitle ? (
            <Typography variant="body2" color="text.secondary">
              {subtitle}
            </Typography>
          ) : null}
        </Stack>
        {children}
      </Paper>

      {footerTitle || actions.length > 0 ? (
        <Paper elevation={0} sx={{ ...authCardSx, py: 2.5 }}>
          <Stack spacing={0.5} alignItems="center">
            {footerTitle ? (
              <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 0.5 }}>
                {footerTitle}
              </Typography>
            ) : null}
            {actions.map((action) => (
              <Button
                key={action.label}
                variant="text"
                onClick={action.onClick}
                sx={{
                  ...authButtonSx,
                  color: "primary.main",
                  py: 0.5,
                }}
              >
                {action.label}
              </Button>
            ))}
          </Stack>
        </Paper>
      ) : null}
    </Stack>
  );
};

export default AuthCard;
